import React from 'react';
import WorkspacePlaceholder from './WorkspacePlaceholder.page';

/**
 * Named destinations for navigation entries whose screens are not built yet.
 *
 * One small component per page rather than a single component reading the URL,
 * so each keeps its own route and replacing one with the real screen is a
 * one-line change in Routes.js that touches nothing else.
 *
 * The `title` on each MUST match the sidebar label that leads here — a page
 * whose heading differs from the item clicked reads as a wrong turn.
 */

/* ── Level 1 ─────────────────────────────────────────────────────────────── */

/** Growth Opportunities — Partner workspace. */
export const GrowthOpportunitiesPlaceholder = () => (
    <WorkspacePlaceholder title="Growth Opportunities" />
);

/** LearnCreator — Partner and School workspaces. */
export const LearnCreatorPlaceholder = () => (
    <WorkspacePlaceholder title="LearnCreator" />
);

/** Insights > School Network Dashboard — School Network workspace only. */
export const SchoolNetworkDashboardPlaceholder = () => (
    <WorkspacePlaceholder title="School Network Dashboard" />
);

/* ── Level 2 · Solutions ─────────────────────────────────────────────────── */

/**
 * The four solution pages below are Common Section: the same screen in the
 * Partner, School and Teacher workspaces. Each carries an Overview and, for
 * some, a Preview — those are Level 3 sidebar rows, defined further down.
 */

/** Solutions > COS Children Assessment (P0). */
export const SolutionChildrenAssessmentPlaceholder = () => (
    <WorkspacePlaceholder title="COS Children Assessment" />
);

/** Solutions > LearnCreator (LC). */
export const SolutionLearnCreatorPlaceholder = () => (
    <WorkspacePlaceholder title="LearnCreator" />
);

/** Solutions > COS Government Checklist (GC) — Partner workspace only. */
export const SolutionGovernmentChecklistPlaceholder = () => (
    <WorkspacePlaceholder title="COS Government Checklist" />
);

/* ── Level 2 · Growth Opportunities ──────────────────────────────────────── */

/** Growth Opportunities > Product Adoption. */
export const ProductAdoptionPlaceholder = () => (
    <WorkspacePlaceholder title="Product Adoption" />
);

/** Growth Opportunities > Portfolio Snapshot. */
export const PortfolioSnapshotPlaceholder = () => (
    <WorkspacePlaceholder title="Portfolio Snapshot" />
);

/* ── Level 3 · Solutions ─────────────────────────────────────────────────── */

/**
 * Each solution's Overview / Preview pair.
 *
 * These are sidebar rows, not tabs: the Navigation Bar sheet gives them the
 * Level 3 Code and Level 3 Name columns, and keeps Tab Code / Tab Name as a
 * separate pair used only by the Settings page.
 *
 * The titles are the sheet's Level 3 names verbatim, so several read simply
 * "Overview" — the sidebar row above them says which solution they belong to.
 *
 * COS Readiness Solution has an Overview and no Preview; the sheet lists none.
 */

/** Solutions > COS Government Checklist > Preview. Sheet note: "Mehreen to create GC Preview". */
export const SolutionGovernmentChecklistPreviewPlaceholder = () => (
    <WorkspacePlaceholder title="Preview" />
);

/* ── Level 3 · Growth Opportunities ──────────────────────────────────────── */

/**
 * Portfolio Snapshot > Executive Overview / Attention Needed.
 *
 * Named pages of their own rather than links into the Partner Dashboard's
 * similarly-named screens: the Dashboards sheet retires both of those from the
 * Partner Dashboard, and Gap Register G063 leaves dashboard deep-links open.
 */
